import { render } from "./doctor-login.vue?vue&type=template&id=4dc83790&scoped=true"
import script from "./doctor-login.vue?vue&type=script&lang=js"
export * from "./doctor-login.vue?vue&type=script&lang=js"

import "./doctor-login.vue?vue&type=style&index=0&id=4dc83790&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dc83790"]])

export default __exports__